import { useActivityFormStore } from "PFApp/activities/activity_form/activity_form_store";
import { ActivityFormState } from "PFApp/activities/activity_form/activity_form_store/activity_form_store.types";
import { useActivityFormSubmit } from "PFApp/activities/activity_form/hooks/use_activity_form_submit";
import { Button } from "PFComponents/button";
import { useTranslation } from "react-i18next";

import css from "../../footer.module.scss";

type EditModeButtonsProps = {
  submitOptions?: ActivityFormState["submitOptions"];
};

export const EditModeButtons = ({ submitOptions }: EditModeButtonsProps) => {
  const { t } = useTranslation("activities", { keyPrefix: "form.footer" });
  const { isDraft } = useActivityFormStore((state) => state.activityStatus);
  const onSubmit = useActivityFormSubmit();

  if (isDraft) {
    return (
      <>
        <Button
          kind="secondary"
          text={t("updateDraft")}
          onClick={() => onSubmit({ ...submitOptions, draft: true })}
          className={css.footerButton}
        />
        <Button
          kind="primary"
          text={t("publish")}
          onClick={() => onSubmit({ ...submitOptions, draft: false })}
          className={css.footerButton}
        />
      </>
    );
  }

  return <Button kind="primary" text={t("update")} onClick={() => onSubmit(submitOptions)} />;
};
